// extracted by mini-css-extract-plugin
export var chip = "_mj-2";
export var chipBody = "_mj-8";
export var chipHeader = "_mj-9";
export var chipWithKind = "_mj-7";
export var icon = "_mj-3";
export var kind = "_mj-a";
export var remove = "_mj-5";
export var removeIcon = "_mj-6";
export var row = "_mj-0";
export var rowHistorical = "_mj-1";
export var text = "_mj-4";